import React,{useState} from 'react'
import { Link } from 'react-router-dom'
import logo from "../../assests/no_image.jpg"
import { FaGreaterThan } from "react-icons/fa6";
import user_default from "../../assests/user_default.png"
import { toast } from 'react-toastify'
import { handleApi } from '../../utils/authentication';


                        
const UserCard = ({user,activeTab,acive_user}) => {

    const [imageUri,setImageUri]=useState(user?.profile_image)

    const [loading,setLoading]=useState(false)

    const handleResendUserInvite = async () => {
        try{
            setLoading(true)
            const formData=new FormData()
       
            formData.append('client_id',user?.client_id)
            formData.append('email',user?.email)
            formData.append('user_setup_password_link_prefix',process.env.REACT_APP_URL+'client/setup_password/');
            
            let result=await handleApi('resend_user_invitation','POST',{},formData)

            if(result?.success){
                toast.success("Invite sent successfully")
            }else{
                toast.error(result?.error?.error_message || "Failed to send invite")
            }
        
        
        }catch(error){
            console.log(error)
            toast.error(error?.message || "Failed to send invite")
        }finally{
            setLoading(false)
        }
    }
    
  return (
    <div className="row px-1 py-3 mx-2 mb-2 campaign_item_card">
    <div className="col-lg-1 col-md-12 position-relative">
        <div className=" position-relative client_profile_image  d-flex justify-content-center align-items-center" style={{borderRadius:'50%',width:'70px',height:'70px'}}>
         {imageUri?
            <img src={user?.profile_image} 
             onError={()=>{
                setImageUri(null)
             }}
             style={{width:'100%',height:'100%',objectFit:'cover'}}
            className="" alt="" />:
            <div style={{width:'100px',height:'100px',borderRadius:'50%',background:'#7F56D94D'}} className=' d-flex justify-content-center align-items-center'>
                 <p className='mb-0 'style={{fontSize:'1.2vw'}}> {user?.first_name[0]?.toUpperCase()} {user?.last_name[0]?.toUpperCase()}</p>
             </div>
            }
          
        </div> 


    </div>
    <div className="col-lg-11 col-md-12 px-4 ">
        {/* <div
            className="d-flex flex-wrap justify-content-between  my-2 pb-2  border-bottom ">
            <div className="d-flex align-items-center gap-1 ">
              
                <p className="mb-0">{user?.client_name}</p>
            </div>
            <span> </span>

        </div> */}
        <div className="row d-flex align-items-center mt-2">
            <div className="col-lg-2 col-md-6  col-6 mt-2">
                <div className="d-flex gap-2">
                    <p className="mb-0">Firstname</p>
                   
                </div>
                <span>{user?.first_name}</span>
            </div>
            <div className="col-lg-2 col-md-6  col-6 mt-2">
                <div className="d-flex gap-2">
                    <p className="mb-0">Lastname</p>
                    
                </div>
                <span>{user?.last_name}</span>
            </div>
            <div className="col-lg-3 col-md-6  col-6 mt-2">
                <div className="d-flex gap-2">
                    <p className="mb-0">Email</p>
               
                </div>
                <span>{user?.email}</span>
            </div>
            <div className="col-lg-1 col-md-6 col-6 mt-2">
                <div className="d-flex gap-2">
                    <p className="mb-0">Role</p>
                
                </div>
                <span>{user?.role_name}</span>
            </div>
            
            <div className="col-lg-1"></div>
            {/* <div className="col-lg-3  d-flex justify-content-end">
                <Link to={``} className="btn  btn-md rounded-pill">View More  
                  <FaGreaterThan />
                </Link>
            </div> */}

        </div>
        <div>
        <div className="  d-flex justify-content-end">
                {(activeTab!=="pending_clients" && !acive_user?.is_super_admin) &&
                <Link to={`${user?.user_id}`} className="btn  btn-md rounded-pill">View More  
                  <FaGreaterThan />
                </Link>}
                {activeTab==="pending_clients" &&
                 <button className="btn btn-md btn-primary rounded-pill" onClick={handleResendUserInvite} disabled={loading}>
                    {loading ? "Sending..." : "Resend Invite"}
                    </button>}
         </div>

        </div>

    </div>
</div>
  )
}

export default UserCard